module.exports = __webpack_public_path__ + "img/gem-light-inactive.c0325f35.png";